var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: {
        ipConnectAdd: _vm.type == "4",
      },
      attrs: { id: "addPrinter" },
    },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title:
              _vm.type !== "4"
                ? _vm.$t("AddPrinter")
                : _vm.$t("ConnectByIPLAN"),
            visible: _vm.dialogVisible,
            "close-on-click-modal": false,
            "destroy-on-close": true,
            "lock-scroll": false,
            "modal-append-to-body": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.viewClose,
          },
        },
        [
          _c("div", { staticClass: "printer" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.type == "1",
                    expression: "type == '1'",
                  },
                ],
                staticClass: "netConnect",
              },
              [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.step == "1",
                        expression: "step == '1'",
                      },
                    ],
                    staticClass: "find",
                  },
                  [
                    _c("img", {
                      staticClass: "findImg",
                      attrs: { src: _vm.getImg },
                    }),
                    _c("span", { staticClass: "findLabel" }, [
                      _vm._v(_vm._s(_vm.$t("FindingDevices"))),
                    ]),
                    _c("span", { staticClass: "findTip1" }, [
                      _vm._v(_vm._s(_vm.$t("LANConnectionNote1"))),
                    ]),
                    _c("span", { staticClass: "findTip2" }, [
                      _vm._v(_vm._s(_vm.$t("LANConnectionNote2"))),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.step == "2",
                        expression: "step == '2'",
                      },
                    ],
                    staticClass: "result",
                  },
                  [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.havePrinter,
                            expression: "havePrinter",
                          },
                        ],
                        staticClass: "haveRes",
                      },
                      [
                        _c("div", { staticClass: "title" }, [
                          _c("div", { staticClass: "titleLeft" }, [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("lan_connection")) +
                                " (" +
                                _vm._s(_vm.lanPrinterList.length) +
                                ") "
                            ),
                          ]),
                          _c("div", { staticClass: "titleRight" }, [
                            _c(
                              "div",
                              {
                                staticClass: "btn",
                                on: { click: _vm.reSearch },
                              },
                              [_vm._v(_vm._s(_vm.$t("refresh")))]
                            ),
                          ]),
                        ]),
                        _c(
                          "div",
                          {
                            staticClass: "printerList",
                            staticStyle: { "margin-bottom": "25px" },
                          },
                          _vm._l(_vm.lanPrinterList, function (item, index) {
                            return _c(
                              "div",
                              { key: index, staticClass: "printerItem" },
                              [
                                _c("div", { staticClass: "itemTop" }, [
                                  _c("div", { staticClass: "topLeft" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "name",
                                        attrs: { title: item.name },
                                      },
                                      [_vm._v(_vm._s(item.name))]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "model",
                                        attrs: { title: item.model },
                                      },
                                      [_vm._v(_vm._s(item.model))]
                                    ),
                                    _c("div", { staticClass: "lan" }, [
                                      _c("img", {
                                        attrs: {
                                          src: require("../../../assets/imgs/lanIcon.png"),
                                        },
                                      }),
                                      _c("span", [
                                        _vm._v(_vm._s(_vm.$t("LAN"))),
                                      ]),
                                    ]),
                                    _c("div", { staticClass: "ip" }, [
                                      _vm._v(
                                        _vm._s(item.ip && `IP: ${item.ip}`)
                                      ),
                                    ]),
                                  ]),
                                  _c("div", { staticClass: "topRight" }, [
                                    _c("img", {
                                      attrs: { src: _vm.formmatImg(item) },
                                    }),
                                  ]),
                                ]),
                                _c(
                                  "div",
                                  {
                                    staticClass: "itemBottom",
                                    on: {
                                      click: function ($event) {
                                        return _vm.lanThrottle(item)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("ConnectPrinter")) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            )
                          }),
                          0
                        ),
                        _c("div", { staticClass: "title" }, [
                          _c("div", { staticClass: "titleLeft" }, [
                            _c(
                              "span",
                              { staticStyle: { "margin-right": "24px" } },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("cloud_printer_connection")) +
                                    " (" +
                                    _vm._s(_vm.cloudPrinterList.length) +
                                    ")"
                                ),
                              ]
                            ),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !_vm.token,
                                    expression: "!token",
                                  },
                                ],
                                staticClass: "tip",
                                staticStyle: {
                                  "font-family": "AlibabaPuHuiTi-3-55-Regular",
                                },
                              },
                              [
                                _vm._v(_vm._s(_vm.$t("LoginToUse")) + "，"),
                                _c(
                                  "span",
                                  {
                                    staticClass: "link",
                                    on: {
                                      click: function ($event) {
                                        return _vm.tologin()
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("LoginNow")))]
                                ),
                              ]
                            ),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.token,
                                    expression: "token",
                                  },
                                ],
                                staticClass: "tipLogin",
                                staticStyle: {
                                  "font-family": "AlibabaPuHuiTi-3-55-Regular",
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("LoggedIn")))]
                            ),
                          ]),
                          _c("div", { staticClass: "titleRight" }),
                        ]),
                        _c(
                          "div",
                          { staticClass: "printerList" },
                          _vm._l(_vm.cloudPrinterList, function (item, index) {
                            return _c(
                              "div",
                              { key: index, staticClass: "printerItem" },
                              [
                                _c("div", { staticClass: "itemTop" }, [
                                  _c("div", { staticClass: "topLeft" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "name",
                                        attrs: { title: item.name },
                                      },
                                      [_vm._v(_vm._s(item.name))]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "model",
                                        attrs: { title: item.model },
                                      },
                                      [_vm._v(_vm._s(item.model))]
                                    ),
                                    _c("div", { staticClass: "cn" }, [
                                      _vm._v(_vm._s(item.cn)),
                                    ]),
                                  ]),
                                  _c("div", { staticClass: "topRight" }, [
                                    _c("img", {
                                      attrs: { src: _vm.formmatImg(item) },
                                    }),
                                  ]),
                                ]),
                                _c(
                                  "div",
                                  {
                                    staticClass: "itemBottom",
                                    style: {
                                      background: !_vm.token ? "#BDD6FC" : "",
                                      cursor: !_vm.token ? "not-allowed" : "",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.connectCloud(item)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("ConnectPrinter")) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            )
                          }),
                          0
                        ),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.havePrinter,
                            expression: "!havePrinter",
                          },
                        ],
                        staticClass: "nohaveRes",
                      },
                      [
                        _c("img", {
                          staticClass: "findImg",
                          attrs: {
                            src: require("../../../assets/imgs/noPrinter.png"),
                          },
                        }),
                        _c("span", { staticClass: "findLabel" }, [
                          _vm._v(_vm._s(_vm.$t("no_device_found"))),
                        ]),
                        _c("span", { staticClass: "findTip1" }, [
                          _vm._v(_vm._s(_vm.$t("LANConnectionNote1"))),
                        ]),
                        _c("span", { staticClass: "findTip2" }, [
                          _vm._v(_vm._s(_vm.$t("LANConnectionNote2"))),
                        ]),
                      ]
                    ),
                  ]
                ),
              ]
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.type == "2",
                    expression: "type == '2'",
                  },
                ],
                staticClass: "CnConnect",
                on: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return _vm.addCn.apply(null, arguments)
                  },
                },
              },
              [
                _c("div", { staticClass: "cnMain" }, [
                  _c("div", { staticClass: "cnImg" }, [
                    _c("img", {
                      attrs: {
                        src: require("../../../assets/imgs/CNPrinter.png"),
                      },
                    }),
                  ]),
                  _c("div", { staticClass: "cnTip" }, [
                    _c(
                      "div",
                      {
                        staticClass: "label",
                        staticStyle: { "margin-top": "46px" },
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("Step1")) + " ")]
                    ),
                    _c("div", { staticClass: "label" }, [
                      _vm._v(_vm._s(_vm.$t("Step2"))),
                    ]),
                    _c("div", { staticClass: "label" }, [
                      _vm._v(_vm._s(_vm.$t("Step3"))),
                    ]),
                    _c("div", { staticClass: "label" }, [
                      _vm._v(" " + _vm._s(_vm.$t("Step4")) + " "),
                    ]),
                  ]),
                ]),
                _c("div", { staticClass: "cnCodeTitle" }, [
                  _vm._v(_vm._s(_vm.$t("EnterDeviceCN"))),
                ]),
                _c(
                  "div",
                  { staticClass: "cnCodeBox" },
                  [
                    _vm._l([0, 1, 2, 3], function (item) {
                      return _c(
                        "div",
                        {
                          key: item,
                          staticClass: "code-item",
                          class:
                            _vm.codeValue.length == item && _vm.inputFocus
                              ? "code-item-active"
                              : "",
                        },
                        [_vm._v(" " + _vm._s(_vm.codeValue[item]) + " ")]
                      )
                    }),
                    _c("div", { staticClass: "line" }),
                    _vm._l([4, 5, 6, 7], function (item) {
                      return _c(
                        "div",
                        {
                          key: item,
                          staticClass: "code-item",
                          class:
                            _vm.codeValue.length == item && _vm.inputFocus
                              ? "code-item-active"
                              : "",
                        },
                        [_vm._v(" " + _vm._s(_vm.codeValue[item]) + " ")]
                      )
                    }),
                    _c("div", { staticClass: "line" }),
                    _vm._l([8, 9, 10, 11], function (item) {
                      return _c(
                        "div",
                        {
                          key: item,
                          staticClass: "code-item",
                          class:
                            _vm.codeValue.length == item && _vm.inputFocus
                              ? "code-item-active"
                              : "",
                        },
                        [_vm._v(" " + _vm._s(_vm.codeValue[item]) + " ")]
                      )
                    }),
                    _c("div", { staticClass: "line" }),
                    _vm._l([12, 13, 14, 15], function (item) {
                      return _c(
                        "div",
                        {
                          key: item,
                          staticClass: "code-item",
                          class:
                            _vm.codeValue.length == item && _vm.inputFocus
                              ? "code-item-active"
                              : "",
                        },
                        [_vm._v(" " + _vm._s(_vm.codeValue[item]) + " ")]
                      )
                    }),
                    _c("el-input", {
                      staticClass: "input-code",
                      attrs: { value: _vm.codeValue, maxlength: 16 },
                      on: {
                        input: _vm.codeInputChange,
                        blur: _vm.codeInputBlur,
                        focus: _vm.codeInputFocus,
                        keydown: function ($event) {
                          return _vm.handleKeyDown()
                        },
                      },
                    }),
                  ],
                  2
                ),
              ]
            ),
            _vm.type == "3"
              ? _c("div", { staticClass: "AppConnect" }, [
                  _c("div", { staticClass: "imgBox" }, [
                    _c("img", {
                      attrs: {
                        src: require("../../../assets/imgs/addCloudPrinter.png"),
                      },
                    }),
                  ]),
                  _c("div", { staticClass: "contentBox" }, [
                    _c(
                      "div",
                      {
                        staticClass: "label",
                        staticStyle: { "margin-bottom": "12px" },
                      },
                      [_vm._v(" 1.下载纵维立方 App ")]
                    ),
                    _c("div", { staticClass: "qrBox" }, [
                      _c(
                        "div",
                        { staticClass: "qrItem" },
                        [
                          _c("vue-qr", {
                            attrs: {
                              text: _vm.androidQrUrl,
                              margin: 0,
                              size: 100,
                            },
                          }),
                          _c("span", [_vm._v("Android")]),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "qrItem" },
                        [
                          _c("vue-qr", {
                            attrs: { text: _vm.iosQrUrl, margin: 0, size: 100 },
                          }),
                          _c("span", [_vm._v("iOS")]),
                        ],
                        1
                      ),
                    ]),
                    _c("div", { staticClass: "label" }, [
                      _vm._v(" 2.注册并登录账号，保证与切片软件登录同一账号 "),
                    ]),
                    _c("div", { staticClass: "label" }, [
                      _vm._v(
                        " 3.查看打印机，设置>云平台>更多信息，查看打印机的 CN 码及绑定二维码 "
                      ),
                    ]),
                    _c("div", { staticClass: "label" }, [
                      _vm._v("4.使用纵维立方 App 扫码并绑定设备"),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _vm.type == "4"
              ? _c("div", { staticClass: "IpConnect" }, [
                  _c(
                    "div",
                    {
                      staticClass: "search",
                      on: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.createLanSlice.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "ipConnectTitle" }, [
                        _vm._v(_vm._s(_vm.$t("enter_ip_address"))),
                      ]),
                      _c("el-input", {
                        staticClass: "no_number",
                        staticStyle: { width: "100%" },
                        attrs: {
                          size: "mini",
                          placeholder: _vm.$t("EnterIPAddress"),
                        },
                        on: { input: _vm.handleInput },
                        model: {
                          value: _vm.IPInfo.address,
                          callback: function ($$v) {
                            _vm.$set(_vm.IPInfo, "address", $$v)
                          },
                          expression: "IPInfo.address",
                        },
                      }),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.type == "1" && _vm.step == "2",
                      expression: "type == '1' && step == '2'",
                    },
                  ],
                  staticClass: "tip",
                },
                [
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("CantFindPrinter"))),
                    _c(
                      "span",
                      { staticClass: "link", on: { click: _vm.reSearch } },
                      [_vm._v(_vm._s(_vm.$t("Retry")))]
                    ),
                  ]),
                ]
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.type == "4",
                      expression: "type == '4'",
                    },
                  ],
                  staticClass: "lanTip",
                },
                [
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("LANDiscoveryNote1")) + " "),
                  ]),
                  _c("span", { staticStyle: { "margin-bottom": "24px" } }, [
                    _vm._v(_vm._s(_vm.$t("LANDiscoveryNote2")) + " "),
                  ]),
                ]
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.type == "1",
                      expression: "type == '1'",
                    },
                  ],
                  staticClass: "footerOperate",
                },
                [
                  _c("div", { staticClass: "operateLeft" }, [
                    _vm._v(_vm._s(_vm.$t("OtherConnectionMethods"))),
                  ]),
                  _c("div", { staticClass: "operateRight" }, [
                    _c(
                      "div",
                      {
                        staticClass: "priBtn",
                        class: !_vm.token ? "disBtn" : "",
                        staticStyle: { "margin-right": "8px" },
                        on: {
                          click: function ($event) {
                            return _vm.handleType("2")
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("ConnectByCN")) + " ")]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "priBtn",
                        on: {
                          click: function ($event) {
                            return _vm.handleType("4")
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("ConnectByIP")))]
                    ),
                  ]),
                ]
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.type == "2" || _vm.type == "4",
                      expression: "type == '2' || type == '4'",
                    },
                  ],
                  staticClass: "footerOperate",
                },
                [
                  _c("div", { staticClass: "operateLeft" }, [
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.type == "4" && _vm.ipConnectState,
                            expression: "type == '4' && ipConnectState",
                          },
                        ],
                        class: {
                          ipConnectLoading: _vm.ipConnectState == "loading",
                          ipConnectError: _vm.ipConnectState == "error",
                        },
                      },
                      [_vm._v(_vm._s(_vm.getIpConnectTips(_vm.ipConnectState)))]
                    ),
                  ]),
                  _c(
                    "div",
                    { staticClass: "operateRight" },
                    [
                      _c(
                        "el-button",
                        {
                          staticStyle: { "border-radius": "16px" },
                          attrs: { size: "mini" },
                          on: {
                            click: function ($event) {
                              return _vm.handleType("1")
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("back")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.type == "4",
                              expression: "type == '4'",
                            },
                          ],
                          staticClass: "priBtn",
                          attrs: {
                            size: "mini",
                            type: "primary",
                            disabled:
                              _vm.ipConnectState == "loading" ||
                              !_vm.IPInfo.address.trim(),
                          },
                          on: { click: _vm.createLanSlice },
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("OK")))]
                      ),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.type == "2",
                              expression: "type == '2'",
                            },
                          ],
                          staticStyle: { "border-radius": "16px" },
                          attrs: {
                            size: "mini",
                            type: "primary",
                            disabled: !_vm.codeValue,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.addCn()
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("OK")))]
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }